/**
 * Aviso flotante.
 *
 * Confirma acciones que no tienen otro feedback visible ("mesa cobrada",
 * "recibo descargado"). Se va solo a los 3,2 s: en un POS nadie tiene una
 * mano libre para cerrar notificaciones.
 */

import { useEffect } from 'react';

interface Props {
  texto: string | null;
  onOcultar: () => void;
}

export function Aviso({ texto, onOcultar }: Props) {
  useEffect(() => {
    if (!texto) return;
    const t = window.setTimeout(onOcultar, 3200);
    return () => window.clearTimeout(t);
  }, [texto, onOcultar]);

  return (
    <div className={`toast${texto ? ' on' : ''}`} role="status" aria-live="polite">
      {texto ?? ''}
    </div>
  );
}
